type PageInfo = {
  perPage?: number
  page?: number
}
export type PaginationModel = {
  prev?: PageInfo
  last?: PageInfo
  next?: PageInfo
}
export function linkPaginationParser(
  linkHeader?: string | null
): PaginationModel {
  return (
    linkHeader
      ?.split(',')
      .map((link) => {
        const relMatch = link.match(/rel="(\w+)"/)
        const rel = relMatch
          ? (relMatch[1] as 'next' | 'prev' | 'last')
          : 'undefined'
        const perPageMatch = link.match(/per_page=(\d+)/)
        const perPage = perPageMatch ? +perPageMatch[1] : 1
        const pageMatch = link.match(/page=(\d+)/)
        const page = pageMatch ? +pageMatch[1] : 1
        return { [rel]: { perPage, page } }
      })
      .filter((pageInfo) => !pageInfo['undefined'])
      .reduce((prev, current) => ({ ...prev, ...current }), {}) || {}
  )
}
